export default __webpack_public_path__ + "static/media/celebrating.487ac7d8.svg";